import styled, { css } from 'styled-components';

export const SortButton = styled.button`
    background: none;
    border: 0;
    padding: 0;
    margin: 0;
    font: inherit;
    color: inherit;
    text-transform: inherit;
    text-align: left;
    cursor: pointer;
`;

export const StyledTable = styled.table.withConfig({
    shouldForwardProp: prop => !['variant', 'hasBorders'].includes(prop),
})<{
    variant?: 'simple' | 'striped' | 'unstyled' | 'dense';
    hasBorders: boolean;
}>`
    border-collapse: ${({ hasBorders }) => (hasBorders ? 'separate' : 'collapse')};
    border-spacing: 0;
    border: ${({ theme, hasBorders }) => hasBorders && `1px solid ${theme.gray8}`};
    border-radius: ${({ hasBorders }) => hasBorders && '8px'};

    ${({ hasBorders }) =>
        hasBorders &&
        css`
            thead tr:first-child th:first-child {
                border-top-left-radius: 8px;
            }
            thead tr:first-child th:last-child {
                border-top-right-radius: 8px;
            }
        `}
    font-style: normal;

    /* Variant styles */
    ${({ variant }) => {
        switch (variant) {
            case 'striped':
                return css`
                    tbody tr:nth-of-type(odd) {
                        background-color: ${({ theme }) => theme.gray10};
                    }
                `;
            case 'simple':
                return css`
                    border-radius: 8px;
                    th {
                        background-color: ${({ theme }) => theme.gray11};
                    }
                    th,
                    td {
                        border-bottom: 1px solid ${({ theme }) => theme.gray8};
                    }
                    tbody tr:last-child td {
                        border-bottom: none;
                    }
                `;
            case 'unstyled':
                return css`
                    th,
                    td {
                        border: none;
                        color: ${({ theme }) => theme.gray2};
                    }
                `;
            case 'dense':
                return css`
                    th,
                    td {
                        word-break: break-all;
                    }
                `;
            default:
                return '';
        }
    }}
`;
